/**
 * @generated SignedSource<<1b43d053ad0141ca20a98764eef01ea5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endpointId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "endpointId"
      }
    ],
    "concreteType": "Endpoint",
    "kind": "LinkedField",
    "name": "endpointById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nameUk",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quantity",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceViewOrderItemPalacSportuFancyPagesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "serviceViewOrderItemPalacSportuFancyPagesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5622e01cc36424242e855d6ff64242d0",
    "id": null,
    "metadata": {},
    "name": "serviceViewOrderItemPalacSportuFancyPagesQuery",
    "operationKind": "query",
    "text": "query serviceViewOrderItemPalacSportuFancyPagesQuery(\n  $endpointId: String\n) {\n  endpointById(id: $endpointId) {\n    id\n    name\n    price\n    nameUk\n    quantity\n  }\n}\n"
  }
};
})();

node.hash = "33b7000c36f163dde7ad85b20367ceb7";

module.exports = node;
